import { useEffect } from 'react';

type ThaanaKeyboardCtor = new (className: string, autoStart?: boolean) => unknown;

/**
 * Initializes Thaana keyboard for elements matching `className`.
 * Uses dynamic import — the package only exposes a global constructor.
 */
export function useThaanaKeyboard(className: string = '.thaana-keyboard', autoRun: boolean = true) {
  const selector = className.startsWith('.') ? className : `.${className}`;

  useEffect(() => {
    let cancelled = false;

    void import('thaana-keyboard/ThaanaKeyboard.js').then(() => {
      if (cancelled) return;
      const ThaanaKeyboard = (window as Window & { ThaanaKeyboard?: ThaanaKeyboardCtor })
        .ThaanaKeyboard;
      if (ThaanaKeyboard) {
        new ThaanaKeyboard(selector, autoRun);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [selector, autoRun]);
}
